import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'map', standalone: true })
export class MapPipe<TInput, TResult> implements PipeTransform {
  public transform(val: TInput, exp: (val: TInput) => TResult): TResult {
    return exp(val);
  }
}
